export default ({ onTouchTap, href, connected, ...rest }) => {
  function _onTouchTap(e) {
    e.preventDefault();
    onTouchTap();
  }

  return (
    <a
      {...rest}
      onClick={onTouchTap && _onTouchTap}
      href={href || "#"}
      className="stripe-connect light-blue"
    >
      <span>
        {connected ? "Bank account connected" : "Connect bank account"}
      </span>
    </a>
  );
};



// WEBPACK FOOTER //
// ./src/app/components/partials/connect-with-stripe.jsx